import { fontList } from '../../core/font-list';
import { colorListPairs, colorMap, colorListCharts } from '../../core/color-list';

export let params = {
  'category': 'animation',
  'parameters': {
    'size': {
      'default': {
        'key': '900 x 600',
        'value': [900, 600],
        'label': '900 x 600'
      },
      'label': 'Afmeting',
      'type': 'array',
      'values': [
        {
          'key': '600 x 900',
          'value': [600, 900],
          'label': '600 x 900'
        },
      ],
      'control': 'standard-select',
      'description': 'Afmeting van de visualisatie',
    },
    'width': {
      'default': 900,
      'label': 'Breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'height': {
      'default': 600,
      'label': 'Hoogte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'spaceBetweenBullets': {
      'default': 90,
      'label': 'Afstand tussen bullets',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'bulletRadius': {
      'default': 6,
      'label': 'Radius bullets',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'bulletColor': {
      'default': '#1f74b6',
      'label': 'Kleur bullet',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleText': {
      'default':  'ICT-gebruik in huishoudens 2017',
      'label': 'Titel tekst',
      'type': 'string',
      'control': 'standard-control',
    },
    'text1': {
      'default':  'Voor 87% van hen is internet een dagelijkse\n bezigheid.',
      'label': 'Titel tekst 1',
      'type': 'string',
      'control': 'standard-control',
    },
    'text2': {
      'default':  '84% zoekt er informatie over goederen of diensten.',
      'label': 'Titel tekst 2',
      'type': 'string',
      'control': 'standard-control',
    },
    'text3': {
      'default':  '83% bezoekt sociale netwerken en 62% maakt er\n dagelijks gebruik van.',
      'label': 'Titel tekst 3',
      'type': 'string',
      'control': 'standard-control',
    },
    'text4': {
      'default':  '46% streamt muziek en 48% kijkt naar\n afbeeldingen of video\'s.',
      'label': 'Titel tekst 4',
      'type': 'string',
      'control': 'standard-control',
    },
    'textFontSize': {
      'default': 28,
      'label': 'Font grootte tekst',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textLineHeight': {
      'default': 1.3,
      'label': 'Regelhoogte tekst',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textFontColor': {
      'default': '#222221',
      'label': 'Font kleur tekst',
      'type': 'string',
      'control': 'standard-control',
    },
    'colorScheme': {
      'default': {
        'key': 'grijs',
        'label': 'Grijs',
        'value': ['#f8fafc', '#555555'],
      },
      'control': 'cbs-color-scheme',
    },
    'marginLeft': {
      'default': 40,
      'label': 'Linkermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginRight': {
      'default': 40,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'paddingRight': {
      'default': 50,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginTop': {
      'default': 40,
      'label': 'Bovenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginBottom': {
      'default': 80,
      'label': 'Ondermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'paddingBottom': {
      'default': 40,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'statbelLogoY': {
      'default': 200,
      'label': 'Logo Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'statbelLogoWidth': {
      'default': 720,
      'label': 'Breedte CBS logo',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'bannerHeight': {
      'default': 140,
      'label': 'Banner height',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleOffsetX': {
      'default': 17,
      'label': 'Titel afstand X',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleOffsetY': {
      'default': 70,
      'label': 'Titel 1 afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'title1OffsetY': {
      'default': 40,
      'label': 'Titel 1 afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'title2OffsetY': {
      'default': 78,
      'label': 'Titel 2 afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleText1': {
      'default': 'Steeds meer Belgen gebruiken',
      'label': 'Titel tekst 1',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleText2': {
      'default': 'dagelijks het internet',
      'label': 'Titel tekst 2',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleColor': {
      'default': '#1f74b6',
      'label': 'Titel kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleFontSize': {
      'default': 32,
      'label': 'Titel font grootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleFontWeight': {
      'default': 700,
      'label': 'Titel font dikte',
      'type': 'numeric',
      'control': 'standard-control',
    },
    'minY': {
      'default': 0,
      'label': 'Min Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'maxY': {
      'default': 100,
      'label': 'Max Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'steps': {
      'default': 4,
      'label': 'Steps',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Aantal horizontale lijnen excl. as',
    },
    'unitText': {
      'default': '',
      'label': 'Tekst eenheid',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitTextOffsetY': {
      'default': 35,
      'label': 'Afstand unit boven max',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelSpaceY': {
      'default': 90,
      'label': 'Label ruimte Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Ruimte voor de labelteksten langs de Y-as',
    },
    'labelSpaceX': {
      'default': 70,
      'label': 'Label ruimte X',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelColor': {
      'default': '#555555',
      'label': 'Label kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelFontSize': {
      'default': 24,
      'label': 'Label font grootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelOffsetY': {
      'default': 10,
      'label': 'Label afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand tussen de labels en de Y-as',
    },
    'labelOffsetX': {
      'default': 15,
      'label': 'Label afstand X',
      'type': 'numeric',
      'control': 'standard-number',
    },
    // 'legend': {
    //   'default': true,
    //   'label': 'Show legend',
    //   'type': 'boolean',
    //   'control': 'standard-checkbox',
    // },
    // 'legendRows': {
    //   'default': 1,
    //   'label': 'Aantal rijen in de legend',
    //   'type': 'numeric',
    //   'control': 'standard-number',
    // },
    // 'legendItemWidth' : {
    //   'default': 30,
    //   'label': 'Breede van het legend item',
    //   'type': 'numeric',
    //   'control': 'standard-number',
    //   'description': 'Is de breede van het ledgend item voor de tekst',
    // },
    // 'legendOffsetY' : {
    //   'default': 80,
    //   'label': 'Y offset legenda',
    //   'type': 'numeric',
    //   'control': 'standard-number',
    //   'description': 'Offset van de legends naar de grafiek erboven',
    // },
    // 'legendSpaceBetweenColumns' : {
    //   'default': 180,
    //   'label': 'Breede legenda',
    //   'type': 'numeric',
    //   'control': 'standard-number',
    // },
    // 'legendItemDistance' : {
    //   'default': 30,
    //   'label': 'Afstand tussen de legenda items',
    //   'type': 'numeric',
    //   'control': 'standard-number',
    // },
    // 'legendFontSize' : {
    //   'default': 25,
    //   'label': 'Lettergrotte in de legenda',
    //   'type': 'numeric',
    //   'control': 'standard-number',
    // },
    // 'ledgendSpaceBetweenItemAndText':{
    //   'default': 5,
    //   'label': 'Afstand tussen item en tekst in legenda',
    //   'type': 'numeric',
    //   'control': 'standard-number',
    // },
    'formatLocale': {
      'default': {
        'key': 'nl-nl',
        'value': 'nl-nl',
        'label': 'Nederlands'
      },
      'label': 'Taal',
      'type': 'string',
      'values' : [
        {
          'key': 'nl-nl',
          'value': 'nl-nl',
          'label': 'Nederlands'
        },
        {
          'key': 'en-gb',
          'value': 'en-gb',
          'label': 'Engels'
        }
      ],
      'control': 'standard-select',
      'description': 'Taal voor het formatteren van de Y-as labels',
    },
    'labelDecimalsY': {
      'default': '0',
      'label': 'Label decimalen y',
      'type': 'number',
      'control': 'standard-number',
      'description': 'Aantal cijfers achter de komma in de Y-as labels',
    },
    'leftLabelX': {
      'default': '2006',
      'label': 'Linker label X',
      'type': 'string',
      'control': 'standard-control',
    },
    'rightLabelX': {
      'default': '2017',
      'label': 'Rechter label X',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStroke': {
      'default': '#222221',
      'label': 'As kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStrokeWidth': {
      'default': 3,
      'label': 'As breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'barColor': {
      'default': '#1f74b6',
      'label': 'Staaf kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'barStrokeColor': {
      'default': '#1f74b6',
      'label': 'Staaf rand kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'barStrokeWidth': {
      'default': 0,
      'label': 'Staaf rand breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'barPadding': {
      'default': 0.35,
      'label': 'Staaf tussenafstand',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Gedeelte van de grafiekbreedte gereserveerd voor padding waarde tussen 0 en 1',
    },
    'barAnimation': {
      'default': {
        'key': 'allAtOnce',
        'value': 'allAtOnce',
        'label': 'Alle staven tegelijk'
      },
      'label': 'Staaf animatie',
      'type': 'string',
      'values': [
        {
          'key': 'allAtOnce',
          'value': 'allAtOnce',
          'label': 'Alle staven tegelijk'
        },
        {
          'key': 'oneAfterTheOther',
          'value': 'oneAfterTheOther',
          'label': 'Staven één voor één'
        }
      ],
      'control': 'standard-select',
      'description': 'Animatie van de staven',
    },
    'iconWidth': {
      'default': 140,
      'label': 'Icoon breedte',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Breedte van het icoon',
    },
    'iconStrokeWidth': {
      'default': 3,
      'label': 'Icoon font dikte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'iconOffsetDeltaX': {
      'default': 0,
      'label': 'Icoon afstand delta X',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Verschuiving van het icoon in de x-richting',
    },
    'iconOffsetDeltaY': {
      'default': 0,
      'label': 'Icoon afstand delta Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Verschuiving van het icoon in de x-richting',
    },
    'iconOffsetX': {
      'default': 440,
      'label': 'Icoon afstand X',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand van het icoon t.o.v. de linkerkant',
    },
    'iconOffsetY': {
      'default': 35,
      'label': 'Icoon afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand van het icoon t.o.v. de bovenkant',
    },
  },
  'timings': {
    'pauseBar': {
      'default': 3,
      'label': 'Pause tussen bar en coloranimation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseSlide1': {
      'default': 4,
      'label': 'Pause tussen de 1e en 2e slide',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseSlide2': {
      'default': 4,
      'label': 'Pause slide 2',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide1Animation': {
      'default': 8,
      'label': 'Slide 1 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide2Animation': {
      'default': 1,
      'label': 'Slide 2 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'logoAnimation': {
      'default': 4,
      'label': 'Logo CBS animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseEnd': {
      'default': 6,
      'label': 'Pause aan het einde',
      'type': 'numeric',
      'control': 'standard-number'
    }
  },
  'data': {
    'values': [[54], [60], [64], [67], [73], [77], [78], [80], [83], [82], [85], [86]],
    'columnLimitMin': 1,
    'columnLimitMax': 1,
    'columnLabelNumber': 0,
    'rowLimitMin': 2,
    'rowLimitMax': 12,
    'rowLabelNumber': 0,
  },
  'parameterGroups': [
    {
      'title': 'Primair',
      'collapsed': false,
      'keys': []
     // 'keys': ['size','icon','titleText1', 'titleText2', 'text', 'minY', 'maxY', 'unitText', 'leftLabelX', 'rightLabelX'],
    },
    {
      'title': 'Secundair',
      'collapsed': true,
      'keys': []
     // 'keys': ['steps', 'formatLocale', 'labelDecimalsY', 'legendOffsetY', 'legendSpaceBetweenColumns','iconOffsetDeltaX','iconOffsetDeltaY'],
    }
  ],
  'timingGroups': [
    {
      'title': 'Timing',
      'collapsed': true,
      'keys': []
     // 'keys': ['slide1Animation','pauseSlide2','logoCBSAnimation', 'payoffCBSAnimation','pauseEnd']
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/animations/demo-statbel-triptych-bar/social.params.ts